module.exports = __webpack_public_path__ + "static/img/news21-3.5b0b532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news21-3.jpg
// module id = z6pa
// module chunks = 0